import { useEffect, useRef } from "react";
import { BACKEND_ORIGIN } from "@/lib/api";

/**
 * Connects to the shared backend WebSocket and invokes `onEvent` for each
 * JSON message. Mirrors the mobile client: connect with our own user_id +
 * access token; the server fans out bill events to every participant.
 */
export default function useSocket(userId, onEvent) {
  const handlerRef = useRef(onEvent);
  handlerRef.current = onEvent;

  useEffect(() => {
    if (!userId) return;
    const token = localStorage.getItem("hp_token");
    if (!token) return;

    const wsUrl =
      BACKEND_ORIGIN.replace(/^http/, "ws") + `/api/ws/${userId}?token=${token}`;
    let ws;
    let ping;
    let closed = false;

    const connect = () => {
      ws = new WebSocket(wsUrl);
      ws.onopen = () => {
        ping = setInterval(() => {
          if (ws.readyState === WebSocket.OPEN) ws.send("ping");
        }, 25000);
      };
      ws.onmessage = (e) => {
        if (e.data === "pong") return;
        try {
          handlerRef.current?.(JSON.parse(e.data));
        } catch (err) {
          console.debug("useSocket: ignoring non-JSON message", e.data, err);
        }
      };
      ws.onclose = () => {
        clearInterval(ping);
        if (!closed) setTimeout(connect, 2500);
      };
      ws.onerror = () => ws.close();
    };
    connect();

    return () => {
      closed = true;
      clearInterval(ping);
      ws?.close();
    };
  }, [userId]);
}
